export const REPLAY_SESSION_ID_HEADER = "x-klarify-replay-id";

/**
 * PostHog replays mask every text node (`maskTextSelector: "*"`) because this is
 * a healthcare app. Elements carrying this attribute — and everything nested
 * inside them, including children a later refactor adds — are recorded verbatim,
 * so it may only go on non-PHI diagnostics such as recording timers and the
 * selected microphone. Spread `SESSION_REPLAY_UNMASK_PROPS` rather than writing
 * the attribute out: a typo would silently keep the element masked.
 */
export const SESSION_REPLAY_UNMASK_ATTRIBUTE = "data-ph-unmask";

export const SESSION_REPLAY_UNMASK_SELECTOR = `[${SESSION_REPLAY_UNMASK_ATTRIBUTE}]`;

export const SESSION_REPLAY_UNMASK_PROPS = {
	[SESSION_REPLAY_UNMASK_ATTRIBUTE]: "true",
} as const;
